import { render, staticRenderFns } from "./CopySettingsModal.vue?vue&type=template&id=53b12c94"
import script from "./CopySettingsModal.vue?vue&type=script&lang=js"
export * from "./CopySettingsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports